import { OrganizationRequiredDocument } from './organization-required-document';

export class AccountDocument {
    id: number;
    accountId: number;
    organizationRequiredDocument?: OrganizationRequiredDocument;
    organizationDocumentId?: number;
    documentType?: DocumentType;
    fileName?: string;
    uploadedOn?: string;
    isActive: boolean;

    constructor(accountId: number, organizationDocumentId?: number, documentType?: DocumentType) {
        this.accountId = accountId;
        this.organizationDocumentId = organizationDocumentId;
        this.organizationRequiredDocument = undefined;
        this.fileName = null;
        this.uploadedOn = null;
        this.documentType = documentType;
        this.isActive = true;
    }
}

export enum DocumentType {
    TaxDocument,
    BirthCertificate
}


export class SearchDocumentsRequest {
    accountIds: number[];
    hasDocIds: number[];
    missingDocIds: number[];
    orgIds: number[];

    pageNumber: number;
    pageSize: number;
    sortColumn: SearchDocumentsColumn;

    constructor() {
        this.accountIds = [];
        this.orgIds = [];
        this.hasDocIds = [];
        this.missingDocIds = [];
        this.pageNumber = 1;
        this.pageSize = 100;
        this.sortColumn = undefined;
    }
}

export enum SearchDocumentsColumn {
    Id,
    EmailAddress,
    FirstName,
    LastName
}

export interface SearchDocumentsResponse {
    documents: AccountDocument[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
}
